import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("d2-container", {
    staticClass: "release"
  }, [_c("div", {
    staticClass: "user section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" 房源基本信息（" + _vm._s(_vm.houseForm.houseCode) + "） "), _vm.landlordAuth.house_auth_count > 0 ? _c("el-tag", {
    attrs: {
      type: "success",
      size: "mini"
    }
  }, [_vm._v(_vm._s(_vm.landlordAuth.role == 2 ? "认证转租" : "认证房东") + " ")]) : _vm._e(), _c("span", [_vm._v(" | 注册时间：" + _vm._s(_vm.userInfo.createTime))]), _vm.analysisResult.length ? _c("div", {
    staticClass: "analysis-box"
  }, _vm._l(_vm.analysisResult, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "analysis",
      style: {
        marginBottom: index < _vm.analysisResult.length - 1 ? "8px" : "0"
      }
    }, [_c("el-popover", {
      attrs: {
        placement: "left",
        disabled: !item.list,
        trigger: "click"
      }
    }, [_c("div", _vm._l(item.list, function (i, j) {
      return _c("el-link", {
        key: j,
        attrs: {
          type: "primary"
        },
        on: {
          click: function click($event) {
            return _vm.toChatInfo(i.tenant_id);
          }
        }
      }, [_vm._v(_vm._s(i.tenant_id))]);
    }), 1), _c("div", {
      staticClass: "tag",
      attrs: {
        slot: "reference"
      },
      slot: "reference"
    }, [_vm._v(" " + _vm._s(index + 1) + "、"), _c("el-tag", {
      key: index,
      attrs: {
        size: "small"
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")])], 1)])], 1);
  }), 0) : _vm._e()], 1), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("用户头像")]), _c("div", {
    staticClass: "value flex"
  }, [_c("wlc-upload-image", {
    attrs: {
      width: "140px",
      height: "140px",
      url: _vm.houseForm.avatar,
      preview: true,
      random: true,
      multimediaType: "userProfilePic"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.houseForm, "avatar", $event);
      }
    }
  }), _c("div", {
    staticClass: "user-info"
  }, [_c("div", {
    staticClass: "from"
  }, [_vm._v(" 来自： "), _vm.houseForm.scene == 1 ? _c("span", [_vm._v("用户裂变")]) : _vm.houseForm.scene == 2 && _vm.houseForm.cityMasterInfo && _vm.houseForm.cityMasterInfo.name ? _c("span", [_vm._v("城市大使 "), _vm.houseForm.cityMasterInfo.name ? _c("span", [_vm._v(" - " + _vm._s(_vm.houseForm.cityMasterInfo.name) + " ")]) : _vm._e(), _vm.houseForm.cityMasterInfo.percent ? _c("span", [_vm._v(" - 开发准确率：" + _vm._s(_vm.houseForm.cityMasterInfo.percent) + "% ")]) : _vm._e(), _vm.houseForm.cityMasterInfo.remark ? _c("span", [_vm._v(" - " + _vm._s(_vm.houseForm.cityMasterInfo.remark) + " ")]) : _vm._e()]) : _c("span", [_vm._v("自然用户")]), _c("span", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm.userInfo.landlord_status == 1 ? _c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v("房主会员待审核")]) : _vm._e(), _vm.userInfo.landlord_status == 2 ? _c("el-tag", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v("房主会员")]) : _vm._e(), _vm.userInfo.tenant_status == 1 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "info"
    }
  }, [_vm._v("房客会员待审核")]) : _vm._e(), _vm.userInfo.tenant_status == 2 ? _c("el-tag", {
    attrs: {
      size: "mini",
      type: "info"
    }
  }, [_vm._v("房客会员")]) : _vm._e()], 1)]), _c("div", {
    staticClass: "ip-facility"
  }, [_c("span", [_vm._v(_vm._s(_vm.houseForm.appInfo && _vm.houseForm.appInfo.phoneBrand) + " - ")]), _c("span", [_vm._v(_vm._s(_vm.houseForm.appInfo && _vm.houseForm.appInfo.phoneModel))])]), _c("div", {
    staticClass: "device-risk"
  }, [_vm.deviceRisk.risk_code ? _c("div", {
    staticClass: "row"
  }, [_vm.deviceRisk.risk_code.length ? _c("div", {
    staticClass: "col",
    class: {
      "col-gray": _vm.deviceRisk.risk_level == -1
    }
  }, [_c("span", [_vm._v("数盟 - " + _vm._s(_vm.deviceRisk.risk_code.join("/")))])]) : _vm._e(), _vm.deviceRisk.risk_code.length && (_vm.deviceRisk.status == 1 || _vm.deviceRisk.status == 2) ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.status == 1 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危标记设备 ")]) : _vm._e(), _vm.deviceRisk.status == 2 ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危感知源 "), _vm.deviceRisk.status_remark ? _c("span", [_vm._v(" : " + _vm._s(_vm.deviceRisk.status_remark) + " ")]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("span", {
    staticClass: "line"
  }, [_vm._v("|")]) : _vm._e(), _vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_vm._v(" 高危Wi-Fi感知 "), _vm.getPerceptionCodeName ? _c("span", [_vm._v(": " + _vm._s(_vm.getPerceptionCodeName))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm.deviceRisk.relevance_account > 1 ? _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col"
  }, [_c("span", [_vm._v(" 数盟 - 关联账号 * " + _vm._s(_vm.deviceRisk.relevance_account) + "： ")]), _c("wlc-user-list-pop", {
    attrs: {
      list: _vm.deviceRisk.user_list
    }
  })], 1), _vm.deviceRisk.relevance_account > 1 && _vm.deviceRisk.status == 0 && !_vm.deviceRisk.perception_code ? _c("div", {
    staticClass: "col"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "danger",
      plain: ""
    },
    on: {
      click: _vm.goDeviceList
    }
  }, [_vm._v("设高危 ")])], 1) : _vm._e()]) : _vm._e()]), _c("div", {
    staticClass: "mtb4 wlc-f-c"
  }, [_c("wlc-user-pop", {
    staticStyle: {
      display: "inline-block",
      "margin-right": "10px"
    },
    attrs: {
      info: _vm.userInfo.newUser
    },
    on: {
      saveRemark: _vm.saveRemark
    }
  }), _c("span", [_vm.houseForm.loginType == "one_click_login" ? _c("el-tag", {
    staticClass: "mr8",
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v("一键登录")]) : _vm._e(), _vm.houseForm.appleUnionid ? _c("el-tag", {
    staticClass: "mr8",
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v("苹果登录")]) : _vm._e(), _vm.houseForm.unionid ? _c("el-tag", {
    staticClass: "mr8",
    attrs: {
      size: "small",
      type: "success"
    }
  }, [_vm._v("微信登录")]) : _vm._e()], 1), _vm.risk.virtualNumber ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v("虚拟号 ")]) : _vm._e(), _vm.userInfo.phoneCounty && _vm.userInfo.phoneCounty != "中国" ? _c("el-tag", {
    staticClass: "mr8 wlc-important-tag",
    attrs: {
      size: "small",
      type: "danger"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.phoneCounty) + " ")]) : _vm._e(), _c("el-input", {
    staticClass: "w200",
    attrs: {
      size: "mini",
      disabled: ""
    },
    model: {
      value: _vm.houseForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "phone", $$v);
      },
      expression: "houseForm.phone"
    }
  }, [_c("el-button", {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: _vm.houseForm.phone,
      expression: "houseForm.phone",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: _vm.onCopy,
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: _vm.onError,
      expression: "onError",
      arg: "error"
    }],
    attrs: {
      slot: "append",
      icon: "el-icon-document-copy"
    },
    slot: "append"
  }, [_vm._v("复制 ")])], 1)], 1), _c("div", [_vm.houseForm.logoutCount > 0 ? _c("el-tag", {
    attrs: {
      size: "small",
      type: "danger"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toUserPage(_vm.houseForm.phone);
      }
    }
  }, [_vm._v("注销+" + _vm._s(_vm.houseForm.logoutCount) + " ")]) : _vm._e()], 1)]), _vm.userTag.length > 0 ? _c("div", {
    staticClass: "user-tag"
  }, [_c("wlc-user-table-tag", {
    attrs: {
      height: "120px",
      width: "320px",
      userId: _vm.$route.query.userId,
      list: _vm.userTag
    }
  })], 1) : _vm._e(), !_vm.loading ? _c("wlc-radar-chart", {
    attrs: {
      id: _vm.houseForm.id
    }
  }) : _vm._e(), !_vm.loading && _vm.showQuarterRadar ? _c("wlc-quarter-radar-chart", {
    attrs: {
      id: _vm.houseForm.id
    }
  }) : _vm._e()], 1)]), _c("el-row", {
    staticClass: "mtb20",
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("昵称")]), _c("div", {
    staticClass: "value prompts-box"
  }, [_c("el-input", {
    staticClass: "w200",
    class: {
      risk: _vm.risk.name
    },
    model: {
      value: _vm.houseForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "name", $$v);
      },
      expression: "houseForm.name"
    }
  }), _vm.prompts.name ? _c("div", {
    staticClass: "prompts",
    staticStyle: {
      width: "200px"
    }
  }, [_vm._v(" " + _vm._s(_vm.prompts.name) + " ")]) : _vm._e()], 1)])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("备注")]), _c("div", {
    staticClass: "value prompts-box"
  }, [_c("el-input", {
    on: {
      focus: function focus($event) {
        _vm.stopShortcutEvent = true;
      },
      blur: function blur($event) {
        _vm.stopShortcutEvent = false;
      }
    },
    model: {
      value: _vm.houseForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "remark", $$v);
      },
      expression: "houseForm.remark"
    }
  }), _vm.prompts.remark ? _c("div", {
    staticClass: "prompts"
  }, [_vm._v(" " + _vm._s(_vm.prompts.remark) + " ")]) : _vm._e()], 1)])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("职业")]), _c("div", {
    staticClass: "value prompts-box"
  }, [_c("el-input", {
    class: {
      risk: _vm.risk.occupation
    },
    model: {
      value: _vm.houseForm.occupation,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "occupation", $$v);
      },
      expression: "houseForm.occupation"
    }
  }), _vm.prompts.occupation ? _c("div", {
    staticClass: "prompts"
  }, [_vm._v(" " + _vm._s(_vm.prompts.occupation) + " ")]) : _vm._e()], 1)])])], 1), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("个人说明（主页）")]), _c("div", {
    staticClass: "value prompts-box"
  }, [_c("el-input", {
    class: {
      risk: _vm.risk.personalDescription
    },
    attrs: {
      type: "textarea",
      autosize: ""
    },
    model: {
      value: _vm.houseForm.introduce,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "introduce", $$v);
      },
      expression: "houseForm.introduce"
    }
  }), _vm.prompts.introduce ? _c("div", {
    staticClass: "prompts"
  }, [_vm._v(" " + _vm._s(_vm.prompts.introduce) + " ")]) : _vm._e()], 1)])], 1), _c("wlc-conversation-list"), _c("div", {
    staticClass: "media section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" 照片&视频 "), _c("MediumRecordLog", {
    attrs: {
      list: _vm.houseRecord,
      info: _vm.houseForm,
      rentList: _vm.houseConfig.rentTypeList
    }
  }), _vm.redBookAccount ? _c("div", {
    staticClass: "red-num wlc-f-c",
    on: {
      click: _vm.toRedBook
    }
  }, [_vm._v(" 小红书：" + _vm._s(_vm.redBookAccount) + " ")]) : _vm._e()], 1), _c("wlc-upload-video", {
    attrs: {
      url: _vm.houseForm.video,
      preview: true,
      remove: true,
      width: "200px",
      height: "150px",
      multimediaType: "housingVideo"
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.houseForm, "video", $event);
      }
    }
  }), _vm._l(_vm.houseForm.imgs, function (img, index) {
    return _c("div", {
      directives: [{
        name: "dragging",
        rawName: "v-dragging",
        value: {
          item: img,
          list: _vm.houseForm.imgs,
          group: "img"
        },
        expression: "{\n                    item: img,\n                    list: houseForm.imgs,\n                    group: 'img',\n                }"
      }],
      key: img,
      staticClass: "image-item",
      style: {
        "background-image": "url(" + _vm.thumbnailUrl(img) + ")"
      },
      on: {
        click: function click($event) {
          return _vm.previewImage(index);
        }
      }
    }, [_vm.imgScore.get(_vm.sliceImgURl(img)) ? _c("ul", {
      staticClass: "img-score"
    }, _vm._l(_vm.imgScore.get(_vm.sliceImgURl(img)), function (item, index) {
      return _c("li", {
        key: index
      }, [_c("span", {
        style: {
          color: item.isRed ? "#f56c6c" : ""
        }
      }, [_vm._v(_vm._s(item.label))]), _vm._v(" ：" + _vm._s(item.value) + " ")]);
    }), 0) : _vm._e(), _vm.imgsCensor[img] && _vm.imgsCensor[img].censor_status == "block" ? _c("el-button", {
      attrs: {
        type: "danger",
        size: "small"
      }
    }, [_vm.imgsCensor[img].censor_label == "qr_code" ? _c("span", [_vm._v("二维码")]) : _vm._e(), _vm.imgsCensor[img].censor_label == "bar_code" ? _c("span", [_vm._v("一维码")]) : _vm._e(), _vm.imgsCensor[img].censor_label == "summary_ads" ? _c("span", [_vm._v("文字广告")]) : _vm._e(), _vm.imgsCensor[img].censor_label == "ad" ? _c("span", [_vm._v("其他广告")]) : _vm._e()]) : _vm._e(), _c("div", {
      staticClass: "icon-group"
    }, [_c("i", {
      staticClass: "fa fa-eye",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.previewImage(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-repeat",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.selectRotateImg(index);
        }
      }
    }), _c("i", {
      staticClass: "fa fa-close",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.removeImgae(index);
        }
      }
    })])], 1);
  }), _c("wlc-upload-image", {
    attrs: {
      url: _vm.newHouseImageUrl,
      visible: false,
      width: "200px",
      height: "150px",
      multimediaType: "housingPic"
    },
    on: {
      "update:url": function updateUrl($event) {
        _vm.newHouseImageUrl = $event;
      }
    }
  }), _c("div", {
    staticClass: "section-header"
  }, [_vm._v("房源描述")]), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "value prompts-box"
  }, [_c("el-input", {
    class: {
      risk: _vm.risk.houseDescription
    },
    attrs: {
      type: "textarea",
      autosize: ""
    },
    model: {
      value: _vm.houseForm.desc,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "desc", $$v);
      },
      expression: "houseForm.desc"
    }
  }), _vm.prompts.desc ? _c("div", {
    staticClass: "prompts",
    domProps: {
      innerHTML: _vm._s(_vm.prompts.desc)
    }
  }) : _vm._e()], 1)]), _c("div", {
    staticClass: "section-header"
  }, [_vm._v("个人描述（房源）")]), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "value prompts-box"
  }, [_c("el-input", {
    class: {
      risk: _vm.risk.housePersonalDescription
    },
    attrs: {
      type: "textarea",
      autosize: ""
    },
    model: {
      value: _vm.houseForm.personalDesc,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "personalDesc", $$v);
      },
      expression: "houseForm.personalDesc"
    }
  }), _vm.prompts.personalDesc ? _c("div", {
    staticClass: "prompts",
    domProps: {
      innerHTML: _vm._s(_vm.prompts.personalDesc)
    }
  }) : _vm._e()], 1)])], 2), _c("div", {
    staticClass: "rent section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v(" 租金/押金 "), _c("el-select", {
    staticClass: "ml20 w100",
    class: {
      risk: _vm.risk.rentUint
    },
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.houseForm.currencyUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "currencyUnit", $$v);
      },
      expression: "houseForm.currencyUnit"
    }
  }, _vm._l(_vm.houseConfig.currencyUnit, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1), _c("el-row", [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("租金/月")]), _c("div", {
    staticClass: "value flex"
  }, [_c("RecordLog", {
    attrs: {
      list: _vm.houseRecord,
      info: _vm.houseForm
    }
  }, [_c("el-input", {
    staticClass: "w100",
    model: {
      value: _vm.houseForm.rent,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "rent", $$v);
      },
      expression: "houseForm.rent"
    }
  })], 1)], 1)])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("押金")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    staticClass: "w100",
    model: {
      value: _vm.houseForm.deposit,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "deposit", $$v);
      },
      expression: "houseForm.deposit"
    }
  })], 1)])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("租金/日")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    staticClass: "w100",
    model: {
      value: _vm.houseForm.dailyRent,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "dailyRent", $$v);
      },
      expression: "houseForm.dailyRent"
    }
  })], 1)])])], 1)], 1), _c("div", {
    staticClass: "base section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("房源详情")]), _c("div", {
    staticClass: "form-item form-item-flex"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("类型标签")]), _c("div", {
    staticClass: "form-value—item"
  }, [_c("el-checkbox-group", {
    model: {
      value: _vm.typeTagsVal,
      callback: function callback($$v) {
        _vm.typeTagsVal = $$v;
      },
      expression: "typeTagsVal"
    }
  }, _vm._l(_vm.typeTags, function (tag) {
    return _c("el-checkbox", {
      key: tag.id,
      attrs: {
        size: "small",
        label: tag.id,
        border: ""
      }
    }, [_vm._v(_vm._s(tag.ch) + " ")]);
  }), 1)], 1)]), _c("div", {
    staticClass: "form-item form-item-flex mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("房源标签")]), _c("div", {
    staticClass: "form-value—item",
    staticStyle: {
      "line-height": "40px"
    },
    on: {
      click: function click($event) {
        return _vm.selectHouseTag($event);
      }
    }
  }, [_vm._l(_vm.houseTag, function (house, index) {
    return _c("el-tag", {
      directives: [{
        name: "dragging",
        rawName: "v-dragging",
        value: {
          item: house,
          list: _vm.houseTag,
          group: "house"
        },
        expression: "{\n                            item: house,\n                            list: houseTag,\n                            group: 'house',\n                        }"
      }],
      key: house.id,
      attrs: {
        type: house.isSelected ? house.risk ? "danger" : "" : "info",
        closable: house.isUserAdd == 1 ? true : false,
        "data-index": index
      },
      on: {
        close: function close($event) {
          return _vm.removeHouseTag(index);
        }
      }
    }, [_vm._v(_vm._s(house.name) + " ")]);
  }), _vm.houseNewVisible ? _c("el-input", {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      size: "small"
    },
    on: {
      blur: _vm.addHouseTag
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addHouseTag.apply(null, arguments);
      }
    },
    model: {
      value: _vm.houseNewValue,
      callback: function callback($$v) {
        _vm.houseNewValue = $$v;
      },
      expression: "houseNewValue"
    }
  }) : _c("el-button", {
    staticClass: "button-new-tag",
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.showHouseInput
    }
  }, [_vm._v("自建标签 ")])], 2)]), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("类型")]), _c("div", {
    staticClass: "value flex"
  }, [_c("RecordLog", {
    attrs: {
      list: _vm.houseRecord,
      info: _vm.houseForm,
      type: "rentType",
      rentList: _vm.houseConfig.rentTypeList
    }
  }, [_c("el-select", {
    staticClass: "w100",
    class: {
      risk: _vm.risk.rentType
    },
    attrs: {
      placeholder: "整租/合租"
    },
    model: {
      value: _vm.houseForm.rentTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "rentTypeId", $$v);
      },
      expression: "houseForm.rentTypeId"
    }
  }, _vm._l(_vm.houseConfig.rentTypeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-select", {
    staticClass: "w100",
    attrs: {
      placeholder: "长租/可短租"
    },
    model: {
      value: _vm.houseForm.timeTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "timeTypeId", $$v);
      },
      expression: "houseForm.timeTypeId"
    }
  }, _vm._l(_vm.houseConfig.timeTypeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1)])]), _c("el-col", {
    attrs: {
      span: 7
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("卧室/洗手间")]), _c("div", {
    staticClass: "value flex"
  }, [_c("RecordLog", {
    attrs: {
      list: _vm.houseRecord,
      info: _vm.houseForm,
      type: "bedroom"
    }
  }, [_c("el-select", {
    staticClass: "w60",
    attrs: {
      placeholder: "卧室"
    },
    model: {
      value: _vm.houseForm.bedroom,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "bedroom", $$v);
      },
      expression: "houseForm.bedroom"
    }
  }, _vm._l(_vm.bedroom, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1), _c("RecordLog", {
    attrs: {
      list: _vm.houseRecord,
      info: _vm.houseForm,
      type: "bathroom"
    }
  }, [_c("el-select", {
    staticClass: "w60",
    attrs: {
      placeholder: "洗手间"
    },
    model: {
      value: _vm.houseForm.bathroom,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "bathroom", $$v);
      },
      expression: "houseForm.bathroom"
    }
  }, _vm._l(_vm.bathroom, function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        label: item,
        value: item
      }
    });
  }), 1)], 1)], 1)])]), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("楼层")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    staticClass: "w60",
    model: {
      value: _vm.houseForm.floor,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "floor", $$v);
      },
      expression: "houseForm.floor"
    }
  })], 1)])]), _c("el-col", {
    attrs: {
      span: 5
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label label-auto"
  }, [_vm._v("面积")]), _c("div", {
    staticClass: "value"
  }, [_c("el-input", {
    staticClass: "w60",
    staticStyle: {
      "margin-right": "10px"
    },
    model: {
      value: _vm.houseForm.area,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "area", $$v);
      },
      expression: "houseForm.area"
    }
  }), _c("el-select", {
    staticClass: "w60",
    model: {
      value: _vm.houseForm.areaUnit,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "areaUnit", $$v);
      },
      expression: "houseForm.areaUnit"
    }
  }, _vm._l(_vm.houseConfig.areaUnit, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.name
      }
    });
  }), 1)], 1)])])], 1)], 1), _c("div", {
    staticClass: "address section"
  }, [_c("div", {
    staticClass: "section-header"
  }, [_vm._v("地址")]), _c("el-row", {
    attrs: {
      gutter: 60
    }
  }, [_c("el-col", {
    attrs: {
      span: 14
    }
  }, [_c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("区域")]), _c("div", {
    staticClass: "value"
  }, [_c("el-select", {
    attrs: {
      placeholder: "城市"
    },
    on: {
      change: _vm.cityChange
    },
    model: {
      value: _vm.houseForm.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "cityId", $$v);
      },
      expression: "houseForm.cityId"
    }
  }, _vm._l(_vm.houseConfig.cityList, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1), _c("el-select", {
    attrs: {
      placeholder: "区域"
    },
    on: {
      change: _vm.districtChange
    },
    model: {
      value: _vm.houseForm.districtId,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "districtId", $$v);
      },
      expression: "houseForm.districtId"
    }
  }, _vm._l(_vm.houseConfig.area, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1)]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("地址")]), _c("div", {
    staticClass: "value"
  }, [_c("div", {
    attrs: {
      id: "pickerBox"
    }
  }, [_c("RecordLog", {
    attrs: {
      list: _vm.houseRecord,
      info: _vm.houseForm,
      type: "address"
    }
  }, [_c("el-autocomplete", {
    staticClass: "wfull",
    class: {
      risk: _vm.risk.positioning
    },
    attrs: {
      "fetch-suggestions": _vm.mapSearch,
      id: "pickerInput"
    },
    on: {
      select: _vm.selectAddress
    },
    model: {
      value: _vm.houseForm.address,
      callback: function callback($$v) {
        _vm.$set(_vm.houseForm, "address", $$v);
      },
      expression: "houseForm.address"
    }
  })], 1), _c("div", {
    attrs: {
      id: "poiInfo"
    }
  })], 1)])]), _c("div", {
    staticClass: "form-item mtb20"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("地铁")]), _c("div", {
    staticClass: "value"
  }, [_vm.houseForm.subwayStation && _vm.houseForm.subwayStation.length > 0 ? _c("div", {
    staticClass: "flex-list"
  }, _vm._l(_vm.houseForm.subwayStation, function (item) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: "success"
      }
    }, [_vm._v(_vm._s(item.name_zh) + " ")]);
  }), 1) : _vm._e(), _vm.houseForm.subwayLine && _vm.houseForm.subwayLine.length > 0 ? _c("div", {
    staticClass: "flex-list",
    staticStyle: {
      "margin-top": "10px"
    }
  }, _vm._l(_vm.houseForm.subwayLine, function (item) {
    return _c("el-tag", {
      key: item.id,
      attrs: {
        type: "warning"
      }
    }, [_vm._v(_vm._s(item.chSubway) + " ")]);
  }), 1) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.houseConfig.subway && _vm.houseConfig.subway.length > 0,
      expression: "\n                                    houseConfig.subway &&\n                                    houseConfig.subway.length > 0\n                                "
    }],
    staticClass: "subway-list"
  }, _vm._l(_vm.houseConfig.subway, function (item) {
    return _c("el-checkbox", {
      key: item.id,
      model: {
        value: item.isSelected,
        callback: function callback($$v) {
          _vm.$set(item, "isSelected", $$v);
        },
        expression: "item.isSelected"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)])])]), _c("el-col", {
    attrs: {
      span: 10
    }
  }, [_c("div", {
    staticClass: "map",
    attrs: {
      id: "map-container",
      tabindex: "0"
    }
  })])], 1)], 1), _vm.$route.query.from != "house_deleted_edit" ? _c("el-row", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "release-btn"
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.release
    }
  }, [_vm._v("保存")]), _vm.houseForm.status == 1 ? _c("wlc-house-pass-button", {
    ref: "passBtn",
    attrs: {
      size: "big",
      btnType: "success",
      houseId: _vm.$route.query.id,
      userId: _vm.$route.query.userId
    },
    on: {
      refresh: _vm.auditComplete,
      preposition: function preposition($event) {
        return _vm.release("pass");
      }
    }
  }) : _vm._e(), _vm.releaseCompleteState ? _c("wlc-btn-notice", {
    attrs: {
      user: _vm.userInfo
    }
  }) : _vm._e(), _vm.btnNextVisible ? _c("wlc-btn-next", {
    ref: "btnNext"
  }) : _vm._e()], 1), _c("el-col", {
    attrs: {
      span: 12,
      align: "right"
    }
  }, [_vm.houseForm.status == 1 && _vm.userInfo.user_type == 0 ? _c("wlc-set-house-type", {
    ref: "authBtn",
    attrs: {
      size: "big",
      btnType: "warning",
      userId: _vm.$route.query.userId,
      houseId: _vm.$route.query.id,
      houseType: 2
    },
    on: {
      refresh: _vm.auditComplete,
      preposition: function preposition($event) {
        return _vm.release("set-house-type");
      }
    }
  }) : _vm._e(), _vm.houseForm.status == 1 && _vm.userInfo.user_type == 0 ? _c("wlc-set-user-type", {
    attrs: {
      size: "big",
      btnType: "warning",
      userId: _vm.$route.query.userId,
      userType: 1,
      houseId: _vm.$route.query.id,
      btnText: "充值"
    },
    on: {
      refresh: _vm.auditComplete,
      preposition: function preposition($event) {
        return _vm.release("set-user-type");
      }
    }
  }) : _vm._e(), _vm.houseForm.status == 1 && _vm.userInfo.user_type == 0 ? _c("wlc-set-user-type", {
    ref: "quarterBtn",
    attrs: {
      size: "big",
      btnType: "warning",
      userId: _vm.$route.query.userId,
      userType: 3,
      houseId: _vm.$route.query.id,
      btnText: "季度"
    },
    on: {
      refresh: _vm.auditComplete,
      preposition: function preposition($event) {
        return _vm.release("set-user-type");
      }
    }
  }) : _vm._e(), _vm.houseForm.status == 1 ? _c("wlc-house-reject-button", {
    attrs: {
      size: "big",
      btnType: "danger",
      houseId: _vm.$route.query.id,
      userId: _vm.$route.query.userId
    },
    on: {
      refresh: _vm.auditComplete
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _c("el-dialog", {
    staticClass: "wlc-image-preview",
    attrs: {
      top: "5vh",
      fullscreen: true,
      visible: _vm.previewDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.previewDialogVisible = $event;
      }
    }
  }, [_c("el-carousel", {
    ref: "carousel",
    attrs: {
      "indicator-position": "none",
      autoplay: false,
      arrow: "always"
    }
  }, _vm._l(_vm.houseForm.imgs, function (item) {
    return _c("el-carousel-item", {
      key: item
    }, [_c("img", {
      staticStyle: {
        width: "100%",
        height: "100%",
        "object-fit": "contain"
      },
      attrs: {
        src: item
      }
    })]);
  }), 1)], 1), _vm.imageRotateDialogVisible ? _c("wlc-image-rotate", {
    attrs: {
      url: _vm.imageRotateUrl,
      multimediaType: "housingPic"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };